module.exports = __webpack_public_path__ + "media/hyper/fonts/dripicons-v2-4cecedd188b606da855d20edfa03e154.svg";